export default "__VITE_ASSET__a32qSTYXCZF05Uz3Qi5h2g__"